import { FC } from "react";
import { ReactComponent as Highlighter } from "assets/img/highlighter.svg";
import Eraser from "assets/img/eraser.svg";

const Footer: FC = () => {

    return (
        <footer className="cmsFooter">
            <div className="pg-container">
                <div className="cmsFooter-wrapper">
                    <div className="cmsFooter__edit">
                        <span
                            className={`cmsFooter__highlighter footer-size`}
                        >
                            <Highlighter
                                style={{ cursor: "pointer", opacity: 0.4 }}
                            />
                        </span>


                        <span className="footer-size">
                            <img
                                src={Eraser}
                                alt="eraser"
                                style={{ opacity: 0.4 }}
                            />
                        </span>
                    </div>
                    <div className="cmsFooter__buttons">
                        <div className="cmsFooter__buttons-wrapper">
                            <button disabled className="btn cancel-btn btn-medium">Clear</button>
                            <button disabled className="btn orange-btn light btn-medium">Pause/Exit</button>
                            <button disabled className="btn cancel-btn btn-medium">Back</button>
                            <button disabled className="btn cancel-btn btn-medium">Next</button>
                            <button disabled className="btn success-btn btn-medium">Finish</button>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
